import React from "react";
import Navbar from './Navbar';
export const PageLayout = ({ children }) => {
  return (
    < >
      <Navbar />
      <div >{children}</div>
      {/* <PageFooter /> */}
    </>
  );
};
